import { SxProps, Theme } from '@mui/material/styles';

const GRADE_COLOR_MAP: Record<string, string> = {
  A: '#1a9e6a',
  B: '#c5a738',
  C: '#d98e30',
  D: '#c65a2e',
  F: '#a93434',
};

const DEFAULT_GRADE_COLOR = '#9E9E9E';

export const getGradeColor = (grade?: string | null): string => {
  if (!grade) return DEFAULT_GRADE_COLOR;
  const normalizedGrade = grade.trim().toUpperCase();
  return GRADE_COLOR_MAP[normalizedGrade] || DEFAULT_GRADE_COLOR;
};

export const getGradeChipSx = (grade?: string | null): SxProps<Theme> => ({
  backgroundColor: getGradeColor(grade),
  color: '#ffffff',
  fontWeight: 700,
  '& .MuiChip-label': {
    px: 1,
  },
});
